export default "__VITE_ASSET__ZuxE$gBV__"